import { parseDate } from 'utils/datetime'

import { LeadAppointment, LeadCallLogActivity, LeadNote, LiveCallLog } from 'store/types/lead'
import { BaseAddress } from 'types/global'
import { formatDatetime } from 'utils/datetime'
import { ThemeColor } from 'utils/colors'

import { InputAddonProps } from './types'
import { RecipientsType } from './EmailLog/components/Recipients'

const AddressFieldsOrder: Array<keyof BaseAddress> = [
  'addressLine1',
  'addressLine2',
  'suburb',
  'city',
  'province',
  'country',
  'postalCode',
]

export const constructDateTimeValue = ({ date, time }: { date: string; time: string }) => parseDate(`${date} ${time}`)

export const formatAddressDisplay = (value: BaseAddress) => {
  const addressValues: string[] = []

  AddressFieldsOrder.forEach((key) => {
    if (value[key]) {
      addressValues.push(value[key] as string)
    }
  })

  return addressValues.join(', ')
}

export const isDirtyAppointment = (initialValues: LeadAppointment, values: LeadAppointment) =>
  values.title !== initialValues.title ||
  JSON.stringify(values.assigneeIds) !== JSON.stringify(initialValues.assigneeIds) ||
  formatAddressDisplay(values.address) !== formatAddressDisplay(initialValues.address) ||
  formatDatetime(values.startTime) !== formatDatetime(initialValues.startTime) ||
  values.duration !== initialValues.duration ||
  values.isAllDay !== initialValues.isAllDay ||
  values.note !== initialValues.note

export const isDirtyCallLog = (currentValues: LeadCallLogActivity, originalValues: LeadCallLogActivity) =>
  currentValues.callTime !== originalValues.callTime ||
  currentValues.callStatusId !== originalValues.callStatusId ||
  currentValues.callStatusOutcomeId !== originalValues.callStatusOutcomeId ||
  currentValues.callNote !== originalValues.callNote ||
  currentValues.contactInfo !== originalValues.contactInfo

export const isDirtyLiveCallLog = (currentValues: LiveCallLog, originalValues: LiveCallLog) =>
  currentValues.callStatusId !== originalValues.callStatusId ||
  currentValues.callStatusOutcomeId !== originalValues.callStatusOutcomeId ||
  currentValues.callNote !== originalValues.callNote

export const isDirtyNote = (currentValues: LeadNote, originalValues: LeadNote) =>
  currentValues.note !== originalValues.note

export const resolveIconColor = ({
  iconColor,
  inputState,
  isFocused,
}: {
  iconColor?: ThemeColor
  inputState: InputAddonProps['inputState']
  isFocused: InputAddonProps['isFocused']
}): ThemeColor =>
  iconColor ||
  (inputState === 'active' && isFocused
    ? 'blue1'
    : inputState === 'disabled'
    ? 'gray4'
    : inputState === 'error'
    ? 'red'
    : 'gray5')

export const getEmails = (emailList: RecipientsType) => {
  if (Array.isArray(Object.values(emailList))) {
    return Object.values(emailList)
      .flat()
      ?.map((email) => email?.value ?? email)
  }
  return []
}
